import { useState, useEffect } from "react";
import useWebSocket from "react-use-websocket";

export const useWebsocketFetchFinancialDocs = ({ onSuccessFinancial }) => {
  const [socketUrl, setSocketUrl] = useState(null);
  const [statusFinancial, setStatus] = useState("off");
  const [dataFinancial, setData] = useState([]);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(socketUrl, {
    onOpen: () => {
      // console.log(`Connected to App WS financial`);
      setStatus("on");
      setData([]);
    },
    onClose: () => {
      // console.log("close financial");
      if (
        (dataFinancial?.length === 0 && statusFinancial === "fetching") ||
        (dataFinancial?.length === 1 &&
          (dataFinancial[0]?.MessageResponse === "Nenhum registro localizado." ||
          dataFinancial[0]?.MessageResponse === "Falha em validação de filtros!"))
      ) {
        setStatus("empty");
      }

      if (dataFinancial.length !== 0) {
        onSuccessFinancial(dataFinancial);
        setStatus("off");
      }
      setData([]);
    },
    onError: () => {
      // console.log('erro');
      setStatus("error");
    },
    shouldReconnect: () => true,
    reconnectInterval: 2000,
  });

  const handleFetchDataFinancial = (data) => {
    // console.log("data request financial", data);
    setStatus("fetching");
    sendJsonMessage(data);
  };

  const handleFetchUrlFinancial = (url) => {
    setSocketUrl(url);
  };

  const onMessageReceive = (response) => {
    // console.log("response financial-->", response);
    if (
      !response?.Result ||
      response?.message === "Forbidden" ||
      response?.Result[0]?.MessageResponse === "Nenhum registro localizado." ||
      response?.Result[0]?.MessageResponse === "Falha em validação de filtros!"
    ) {
      setStatus("empty");
      return;
    }
    setData([...dataFinancial, ...response?.Result]);
  };

  useEffect(() => {
    if (lastJsonMessage) {
      onMessageReceive(lastJsonMessage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastJsonMessage]);

  return {
    handleFetchDataFinancial,
    handleFetchUrlFinancial,
    dataFinancial,
    statusFinancial,
  };
};
